"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
require("emdataview");
var web_1 = __importDefault(require("../../config/web"));
var tophqtable_1 = __importDefault(require("../../src/modules/quteinfo/tophqtable"));
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var moment_1 = __importDefault(require("moment"));
var base_1 = __importDefault(require("./base"));
var code = stockInfo.code;
// 头部行情渲染
var html = "<a href=\"/zjlx/" + code + ".html\">\u8D44\u91D1\u6D41</a>\n<a href=\"/stockdata/" + code + ".html\" target=\"_blank\" style=\"margin:0 5px;\">\u6570\u636E</a>\n<a href=\"/notices/stock/" + code + ".html\" target=\"_blank\">\u516C\u544A</a>\n<a href=\"//guba.eastmoney.com/list," + code + ".html\" target=\"_blank\">\u80A1\u5427</a>";
//头部行情
tophqtable_1["default"](stockInfo.hqCode, $('#hq_table'), 2, html);
// table数据模块
var opt_history = {
    dataurl: {
        hostname: "datacenter",
        url: "api/data/v1/get",
        params: {
            reportName: "RPT_REFINANCE_TRAN_DEL",
            columns: "ALL",
            source: "WEB",
            client: "WEB",
            pageSize: 50,
            filter: "(SECURITY_CODE=\"" + code + "\")"
        }
    },
    sortname: "TRADE_DATE",
    urlkeyvalues: base_1["default"].urlkeyvalues
};
$("#history").emdataview(opt_history);
// 图模块
var chart = {
    getData: function () {
        var _this = this;
        $.ajax({
            url: web_1["default"].getWebPath('datacenter') + "api/data/v1/get",
            dataType: "jsonp",
            data: {
                reportName: 'RPT_REFINANCE_TRAN_DEL',
                columns: 'ALL',
                sortTypes: 1,
                sortColumns: 'TRADE_DATE',
                filter: "(SECURITY_CODE=\"" + code + "\")"
            },
            success: function (json) {
                var _a;
                var list = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
                if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
                    var obj_1 = { date: [], "new": [], qmye: [] };
                    list.map(function (item) {
                        obj_1.date.push(moment_1["default"](item.TRADE_DATE).format('YYYY-MM-DD'));
                        obj_1["new"].push(utils_1["default"].toFixed2(item.CLOSE_PRICE != '-' ? item.CLOSE_PRICE : obj_1["new"][obj_1["new"].length - 1]));
                        obj_1.qmye.push(utils_1["default"].toFixed2(item.END_BALANCE != '-' ? item.END_BALANCE : obj_1.qmye[obj_1.qmye.length - 1]));
                    });
                    _this.drawChart(obj_1);
                }
            }
        });
    },
    drawChart: function (obj) {
        var dom = document.getElementById("chart");
        var myChart = echarts.init(dom);
        var option = {
            grid: {
                left: 50,
                right: 50,
                top: 20,
                bottom: 60,
                show: true,
                borderWidth: 1,
                borderColor: "#ccc"
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                selectedMode: false,
                bottom: 10
            },
            xAxis: {
                type: 'category',
                data: obj.date,
                // 轴线
                axisLine: {
                    show: false
                },
                // 轴刻度线
                axisTick: {
                    show: false
                }
            },
            yAxis: [
                {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                            color: '#e6e6e6',
                            type: 'dotted'
                        }
                    },
                    // 轴线
                    axisLine: {
                        show: false
                    },
                    // 轴刻度线
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function (value, index) {
                            return utils_1["default"].numFormat(value, 0);
                        }
                    }
                },
                {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    // 轴线
                    axisLine: {
                        show: false
                    },
                    // 轴刻度线
                    axisTick: {
                        show: false
                    },
                }
            ],
            series: [{
                    name: '当日收盘价',
                    type: "line",
                    color: "#FF0101",
                    showSymbol: false,
                    yAxisIndex: 1,
                    lineStyle: {
                        width: 1
                    },
                    data: obj["new"]
                },
                {
                    name: '期末余额(万元)',
                    type: 'line',
                    color: "#004986",
                    showSymbol: false,
                    lineStyle: {
                        width: 1
                    },
                    data: obj.qmye
                }]
        };
        myChart.setOption(option, true);
    }
};
chart.getData();
